import type { ImageOverlayInstance, LayerSourceConfig } from '../types/layer.js';

/**
 * Returns raster image overlay instances for a layer.
 * Legacy shape: single `imageUrl` + `coordinates` → one synthetic instance.
 */
export function getImageOverlayInstances(
  sourceConfig: LayerSourceConfig | undefined,
  layerId: string,
): ImageOverlayInstance[] {
  if (!sourceConfig) {
    return [];
  }
  const instances = sourceConfig.imageInstances;
  if (Array.isArray(instances) && instances.length > 0) {
    return instances;
  }
  const imageUrl = sourceConfig.imageUrl;
  const coordinates = sourceConfig.coordinates;
  if (
    typeof imageUrl === 'string' &&
    imageUrl.length > 0 &&
    Array.isArray(coordinates) &&
    coordinates.length === 4
  ) {
    return [
      {
        id: `${layerId}-img-0`,
        imageUrl,
        coordinates: coordinates as ImageOverlayInstance['coordinates'],
        tilesUrl: sourceConfig.tilesUrl,
        tileBounds: sourceConfig.tileBounds,
        tileMinZoom: sourceConfig.tileMinZoom,
        tileMaxZoom: sourceConfig.tileMaxZoom,
      },
    ];
  }
  return [];
}
